// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:751px){.inner[data-v-63d60ccc]{max-width:12rem;width:100%;display:flex;margin:0 auto 1.58rem;flex-direction:row}}@media screen and (max-width:750px){.inner[data-v-63d60ccc]{max-width:100%;width:100%;display:flex;margin:0 auto 1.58rem;flex-direction:column}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
